$(document).ready(function () {
  $('.closse-pform').click(function(){
    $('.customise-popup').removeClass('active');
  })
  $('.opencpform ').click(function(){
    $('.customise-popup').addClass('active');
  })
  $(".banner-review-button").click(function() {
    //alert();
    $('html, body').animate({
        scrollTop: $(".c-cl").offset().top
    }, 2000);
});
  /**********************************/
 var swiperModal = new Swiper('.before-after-modal-slider .swiper-container', {
      slidesPerView: 1,
      spaceBetween: 10,
      autoHeight: true,
      loop: false,
      observer: true,
      observeParents: true,
      speed: 1500,
      watchActiveIndex: true,
      navigation: {
          nextEl: ".before-after-modal-slider .swiper-button-next",
          prevEl: ".before-after-modal-slider .swiper-button-prev",
      },
  });
  $('.active-index').click(function(){
      var i = $(this).attr('data-index');
      //alert(i);		
      swiperModal[0].slideTo(i);
  })
  $('.close-gallery').click(function(){
    $('.gallery-popup').hide();
  })
  $('.active-index').click(function(){
    $(this).parents('.gallery').find('.gallery-popup').show();
  })
  $('.view-more').click(function(){
    $(this).parents('.gallery').toggleClass('hide-all');
    if ($(this).text() == "View Less")
       $(this).text("View More")
    else
       $(this).text("View Less");
  })
  $( ".gallery" ).each(function( index ) {
    if ($(this).find('.show-this')){      
       $(this).find('.view-button').show();
    }
  })
  /********************************/  
  $('.c-cl').insertAfter('.client-review');
  $('.trustshop-review--summary').insertAfter('.place-rate');
  //$('.installment').insertAfter('.plase-wishlist');
  setTimeout(function() {
      $('.swym-button-bar').insertAfter('.plase-wishlist');
  }, 2500);
  
  /*********************************/
 new Swiper('.home-banner-slider', {
    loop: true,       
    slidesPerView: 1,
    paginationClickable: true,
    spaceBetween: 0,  
    speed:1000,
    autoplay: 
    {
      delay: 3000,
    },
   pagination: 
    {
        el: '.banner-page',
        //dynamicBullets: true,
       clickable: true
    },
  });
  /*********************/
  $('.ring-pop-up').click(function(){
    $('.r-size-popup').show();
  })
  $('.ring-close').click(function(){
    $('.r-size-popup').hide();
  })
  $('.form-control').click(function(){
   //alert();
  })
  /********************/
  $('#t-r-name').on('keydown, keyup', function () {   
    var texInputValue = $('#t-r-name').val();
    $('#r-name').html(texInputValue);
  });
  $('#t-your-name').on('keydown, keyup', function () {   
    var texInputValuea = $('#t-your-name').val();
    $('#your-name').html(texInputValuea);
  });
  /*******************************/
  $('.open-hint').click(function(){
    $('.hint').addClass('active')
  })
  $('.hint-close').click(function(){
    $('.hint').removeClass('active')
  })
  /*************************/
  $('.wish').click(function(){
    alert();
    $('.plase-wishlist').find('a').trigger('click');
  })
  /*****************************/
  $('.buy-more').click(function(){
    $('.m-buy').fadeIn();
    $('.buy-btn').hide();
  })
   /**************FAQ Accordian**************/
    $(".accordion > li > span").click(function() {
        $(this).toggleClass("active").next('div').slideToggle(250)
        .closest('li').siblings().find('span').removeClass('active').next('div').slideUp(250);
    });
  /*************** REMORE TEXT************/
  $('.moreless-button').click(function() {
    event.preventDefault()
    $('.moretext').slideToggle();
    if ($('.moreless-button').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
    /***************** COVERFLOW SWIPPER *******/
      var swiper = new Swiper(".swiper-cover", {
      effect: "coverflow",
      grabCursor: true,
      centeredSlides: true,
      autoHeight: true, //enable auto height      
      autoplay: {
         delay: 3000,
         disableOnInteraction: false,
       },
      coverflowEffect: {
        rotate: 0,
        stretch: 130,
        depth: 80,
        modifier: 5,
        slideShadows: true
      },
      loop: true,
      pagination: {
        el: ".swiper-pagination-cover",
        clickable: true
      },
      breakpoints: {
        640: {
          slidesPerView: 1.5
        },
        768: {
          slidesPerView: 1.5
        },
        1024: {
          slidesPerView: 1.5
        },
        1560: {
          slidesPerView: 1.5
        }
      }
    });
    /******************* NAV MENU************/
    $('.nav-icon').click(function(){
      $('.mobile-menu-body').addClass('active');
    })
    $('.close-menu').click(function(){
      $('.mobile-menu-body').removeClass('active');
      $('.sub_has-children').removeClass('active');
      $('.has-children').removeClass('active');
    })
    $('.first-arrow').click(function(){
      $(this).parents('.has-children').toggleClass('active');
    })
    $('.leave-link').click(function(){
      $(this).parents('.has-children').toggleClass('active');
    })
    $('.second-arrow').click(function(){
      $(this).parents('.sub_has-children').toggleClass('active');
    })
    /*============map-frame-height-calc================*/
    var total_heights = $(".map-frame").outerHeight();
    $(".map-empty").css("height", total_heights);
    if ($(window).width() <= 991){
    $(".map-empty").css("height", 'auto');
    }
    /*============desc-img-height-calc================*/
    var total_heights = $(".desc-img").outerHeight();
    $(".desc-img-empty").css("height", total_heights);
    if ($(window).width() >= 768){
    $(".desc-img-empty").css("height", 'auto');
    }
    /*============refine video================*/
    /*var video = $("#refineVideo").get(0); // Get the video element
    var playIcon = $("#playIcon"); // Get the play icon
    var pauseIcon = $("#pauseIcon"); // Get the pause icon
    // Ensure video plays on page load
    //video.play();
    // Click event for play/pause button
    /*$("#playPauseBtn").on('click', function() {
        if (video.paused) {
            video.play(); // Play the video
            playIcon.hide(); // Hide the play icon
            pauseIcon.show(); // Show the pause icon
        } else {
            video.pause(); // Pause the video
            playIcon.show(); // Show the play icon
            pauseIcon.hide(); // Hide the pause icon
        }
    });*/
  /**************************************/
  if ($(window).width() > 767) {
    $('.common-shape').mouseover(function(){
       var n_sp = $(this).attr('sp-id');
      $('.first-content').hide();
      $('.each-d').hide();
      $("#"+n_sp).show();
    });
    $('.common-shape').mouseout(function(){
      $('.first-content').show();
      $('.each-d').hide();
    });
  }else{
     $(".each-d:first").removeAttr("style");
    // console.log("show")
    $('.common-shape').click(function(){
    
         var n_sp = $(this).attr('sp-id');
        $('.first-content').show();
        $('.each-d').hide();
       
        $("#"+n_sp).show();
      });    
  }
  /***********************************/
  if ($(window).width() > 767) {
    $('.d-img').mouseenter(function(){
        var dm_id = $(this).attr('dm_id');         
        $('.n-dimond-section').addClass(dm_id);      
    });
    $('.n-dimond-section').mouseleave(function(){
        $('.n-dimond-section').removeClass('lab-dimond');      
        $('.n-dimond-section').removeClass('nature-dimond');  
    });
  }else{    
    $('.d-img').click(function(){
        var dm_id = $(this).attr('dm_id');         
        $('.n-dimond-section').addClass(dm_id);      
    });
    $('.d-inn').click(function(){
        $('.n-dimond-section').removeClass('lab-dimond');      
        $('.n-dimond-section').removeClass('nature-dimond');
        var n_id = $(this).attr('n-id'); 
        //alert(n_id);
        $('.n-dimond-section').addClass(n_id);  
    });
  }
  /**********************************/
  $("#HeaderMenu-services, .service-megamenu").mouseenter(function(){
    $(".service-megamenu").show();
  });
  $("#HeaderMenu-services, .service-megamenu").mouseleave(function(){
    $(".service-megamenu").hide();
  });  
  $("#HeaderMenu-shop, .shop-mega-menu").mouseenter(function(){
    $(".shop-mega-menu").show();
  });
  $("#HeaderMenu-shop, .shop-mega-menu").mouseleave(function(){
    $(".shop-mega-menu").hide();
  });  
  /***********************************/
  $("#shopify-section-sections--23027648168256__service_mega_menu_NwAFnC" ).insertAfter( ".service-menu-goes-here" );
  $("#shopify-section-sections--23027648168256__shop_megamenu_cQRWBF" ).insertAfter( ".shop-menu-goes-here" );
  $("#product-form-installment-template--23027647840576__main" ).insertAfter( ".plase-wishlist" );
  $("#shopify-block-trustshop_reviews_widget_product_rating_LCpEVH" ).insertBefore( "#Share-template--23027647840576__main" );
  /*******************MULTISTPE FORM ************/
  var current_fs, next_fs, previous_fs; //fieldsets
  var opacity;
  var current = 1;
  var steps = $("fieldset").length;
  
  setProgressBar(current);
  
  $(".next").click(function(){
  
    current_fs = $(this).parent();
    next_fs = $(this).parent().next();
    
    //Add Class Active
    $("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active");
    
    //show the next fieldset
    next_fs.show();
    //hide the current fieldset with style
    current_fs.animate({opacity: 0}, {
    step: function(now) {
    // for making fielset appear animation
    opacity = 1 - now;
    
    current_fs.css({
      'display': 'none',
      'position': 'relative'
    });
    next_fs.css({'opacity': opacity});
    },
    duration: 500
    });
    setProgressBar(++current);
  });
  
  $(".previous").click(function(){
  
  current_fs = $(this).parent();
  previous_fs = $(this).parent().prev();
  
  //Remove class active
  $("#progressbar li").eq($("fieldset").index(current_fs)).removeClass("active");
  
  //show the previous fieldset
  previous_fs.show();
  
  //hide the current fieldset with style
  current_fs.animate({opacity: 0}, {
  step: function(now) {
  // for making fielset appear animation
  opacity = 1 - now;
  
  current_fs.css({
  'display': 'none',
  'position': 'relative'
  });
  previous_fs.css({'opacity': opacity});
  },
  duration: 500
  });
  setProgressBar(--current);
  });
  
  function setProgressBar(curStep){
  var percent = parseFloat(100 / steps) * curStep;
  percent = percent.toFixed();
  $(".progress-bar")
    .css("width",percent+"%")
  }
  
  $(".submit").click(function(){
    return false;
  })
  setTimeout(() => {
    /**************** RELATED PRODUCT ****************/
    const swipern = new Swiper('.rel-product', {
      // Optional parameters
      loop: true,
      //centeredSlides: true,
      // Navigation arrows
      navigation: {
        nextEl: '.rel-next',
        prevEl: '.rel-prev',
      },
      breakpoints: {
        // when window width is >= 320px
        768: {
          slidesPerView: 1,
          spaceBetween: 30
        },
        // when window width is >= 480px
        1024: {
          slidesPerView: 3,
          spaceBetween: 40
        },
        // when window width is >= 640px
        1280: {
          slidesPerView: 4,
          spaceBetween: 50
        }
      }
    });
  }, 1000);
  /*const swipern = new Swiper('.rel-product', {
      // Optional parameters
      loop: true,
      //centeredSlides: true,
      // Navigation arrows
      navigation: {
        nextEl: '.rel-next',
        prevEl: '.rel-prev',
      },
      breakpoints: {
        // when window width is >= 320px
        768: {
          slidesPerView: 1,
          spaceBetween: 30
        },
        // when window width is >= 480px
        1024: {
          slidesPerView: 3,
          spaceBetween: 40
        },
        // when window width is >= 640px
        1280: {
          slidesPerView: 4,
          spaceBetween: 50
        }
      }
    });*/
});
/*===========Restorations-detail-area img animate================*/
let masks = document.querySelectorAll('.mask');
masks.forEach( mask => {
    let image = mask.querySelector('img');
    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: mask,
            scrub: 3,
            start: "bottom bottom",
            end: "bottom bottom",
            once: true,
        }
    });
    tl.set(mask, {autoAlpha: 1});
    tl.from(mask, 1.5, {
        xPercent: -100,
        ease: Power2.out
    });
    tl.from(image, 1.5, {
        xPercent: 100,
        scale: 1.3,
        delay: -1.5,
        ease: Power2.out
    });
})
/*===============sliding div animation=================*/
gsap.to(".left-block", {
    x: 0,
    opacity: 1,
    duration: 1.5,
    scrollTrigger: {
        trigger: ".resize-repair-area, .gold-gallery-area",
        scrub: 3,
        start: "top 80%",
        end: "top 80%",
        once: true,
    }
});
/***********************************************/


/*****************************************/
gsap.to(".right-block", {
    x: 0,
    opacity: 1,
    duration: 1.5,
    scrollTrigger: {
        trigger: ".resize-repair-area, .gold-gallery-area",
        scrub: 3,
        start: "top 80%",
        end: "top 80%",
        once: true,
    }
});
/*===========jewellery-repairs slider================*/
var swiper = new Swiper('.jewellery-repairs-slider .swiper', {
	slidesPerView: 1,
	spaceBetween: 0,
	loop: false,
	speed: 1500,
    scrollbar: {
        el: ".jewellery-repairs-slider .swiper-scrollbar",
        hide: false,
        draggable: true,
    },
    breakpoints: {
		320: {
			slidesPerView: 1,
			spaceBetween: 16,
            autoplay: {
                enabled: true,
                delay: 2000,
            },
		},
		992: {
			slidesPerView: 1,
			spaceBetween: 30,
		},
        1200: {
			slidesPerView: 1,
			spaceBetween: 30,
		},
		1400: {
			slidesPerView: 1,
			spaceBetween: 59,
		},
	},
});

/*===========jewellery-repairs slider================*/
var swiper = new Swiper('.modeling-info-mobile-wrap .swiper', {
	slidesPerView: 1.2,
	spaceBetween: 20,
	loop: true,
    centeredSlides: true,
	speed: 1500,
    pagination: {
        el: ".modeling-info-mobile-wrap .swiper-pagination",
        clickable: true,
    },
});
/********************/
$(window).scroll(function() {
    var set_mar = $(window).scrollTop() / 5;
    $('.dimond').css('margin-top', set_mar);
    if (set_mar >= 230) { 
        $(".dimond").addClass('fixed');
    } else {
         $(".dimond").removeClass('fixed');
    }    
});
/********** APPROCH SLIDER ***********/
let SwiperTop = new Swiper('.swiper--top', {
  spaceBetween: 0,
  centeredSlides: true,
  speed: 6000,
  autoplay: {
    delay: 1,
  },
  loop: true,
  slidesPerView:'auto',
  allowTouchMove: false,
  disableOnInteraction: true
});
/**********************************/
$(document).ready(function() {
    $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  });




//================= 4c Diamond Insert After  ===========
  $('.dimond-des ').wrap(`<div class="insert_div"></div>`)
$(window).on("load resize",function(e){
  if ($(window).width() < 768) {
  $('.dimond-des ').insertAfter(".first-content");
    
}
else {
    $('.dimond-des').insertAfter(" .insert_div");
    // $(".insert_div").remove();
  
}
});

//================= Gallery Mobile slider  ===========
    var swiper33 = new Swiper(".gallery-mobile-slider-area .mySwiper", {
		slidesPerView: 2,
		spaceBetween: 20,
		loop: true,
		pagination: {
		  el: ".gallery-mobile-slider-area .swiper-pagination",
		  clickable: true,
		},
	});